import * as types from '../../constants/event/freeNFTEventConstants';

export const freeNFTEventListRequest = (
  page,
  pageLength,
  // startAt,
  // endAt,
  // searchString
) => ({
  type: types.FREE_NFT_EVENT_LIST_REQUEST,
  page,
  pageLength,
  // startAt, endAt, searchString
});

export const freeNFTEventList = (list) => ({
  type: types.FREE_NFT_EVENT_LIST,
  list,
});

export const freeNFTEventResponse = (resultCode, message) => ({
  type: types.FREE_NFT_EVENT_RESPONSE_MESSAGE,
  resultCode,
  message,
});

export const freeNFTEventCreate = ({
  mintingCode,
  issuedCount,
  beginAt,
  endAt,
  callback,
  error,
}) => ({
  type: types.FREE_NFT_EVENT_CREATE_REQUEST,
  mintingCode,
  issuedCount,
  beginAt,
  endAt,
  callback,
  error,
});

export const freeNFTEventInfoDetailsRequest = (
  freenftNo,
  page,
  pageLength,
  searchType,
  searchString,
) => ({
  type: types.FREE_NFT_EVENT_INFO_DETAILS_REQUEST,
  freenftNo,
  page,
  pageLength,
  searchType,
  searchString,
});

export const freeNFTEventInfoDetails = (list) => ({
  type: types.FREE_NFT_EVENT_INFO_DETAILS,
  list,
});

export const freeNFTEventInfoUpdateRequest = (
  freenftNo,
  mintingCode,
  issuedCount,
  beginAt,
  endAt,
) => ({
  type: types.FREE_NFT_EVENT_INFO_UPDATE_REQUEST,
  freenftNo,
  mintingCode,
  issuedCount,
  beginAt,
  endAt,
});

export const freeNFTEventInfoDeleteRequest = (eventNo) => ({
  type: types.FREE_NFT_EVENT_INFO_DELETE_REQUEST,
  eventNo,
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setFreeNFTEventListPagination = (page, totalCount) => ({
  type: types.SET_FREE_NFT_EVENT_PAGINATION,
  page,
  totalCount,
});

export const setFreeNFTEventHistoryPagination = (
  page,
  totalCount,
  searchType,
  searchString,
) => ({
  type: types.SET_FREE_NFT_EVENT_PAGINATION,
  page,
  totalCount,
  searchType,
  searchString,
});

export const freeNFTEventPageReset = () => ({
  type: types.FREE_NFT_EVENT_PAGE_RESET,
});
